import PlayerTableRow from '@/utils/classes/PlayerTableRow';
import { getDataTablesCategories } from '@/utils/misc';

// Data structure for the possession table data rows
export const possessionGoalkeeperTableRowItems = [
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.possession.goalkeeper.footwork',
    items: [
      {
        category: '',
        categoryIds: [310],
        translationKey: 'table.possession.goalkeeper.successful_long_pass',
      },
      {
        category: '',
        categoryIds: [311],
        translationKey: 'table.possession.goalkeeper.unsuccessful_long_pass',
      },
      {
        category: '',
        categoryIds: [308],
        translationKey: 'table.possession.goalkeeper.successful_short_pass',
      },
      {
        category: '',
        categoryIds: [309],
        translationKey: 'table.possession.goalkeeper.unsuccessful_short_pass',
      },
    ],
  },
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.possession.goalkeeper.throw',
    items: [
      {
        category: '',
        categoryIds: [304],
        translationKey: 'table.possession.goalkeeper.successful_throw',
      },
      {
        category: '',
        categoryIds: [305],
        translationKey: 'table.possession.goalkeeper.unsuccessful_throw',
      },
    ],
  },
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.possession.goalkeeper.punt',
    items: [
      {
        category: '',
        categoryIds: [306],
        translationKey: 'table.possession.goalkeeper.successful_punt',
      },
      {
        category: '',
        categoryIds: [307],
        translationKey: 'table.possession.goalkeeper.unsuccessful_punt',
      },
    ],
  },
  {
    category: '',
    categoryIds: [323],
    items: null,
    translationKey: 'table.possession.goalkeeper.participation_in_goals',
  },
];

// Data structure for the offensive table data rows
export const offensiveGoalkeeperTableRowItems = [
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.offensive.goalkeeper.footwork',
    items: [
      {
        category: '',
        categoryIds: [310],
        translationKey: 'table.offensive.goalkeeper.successful_long_pass',
      },
      {
        category: '',
        categoryIds: [311],
        translationKey: 'table.offensive.goalkeeper.unsuccessful_long_pass',
      },
      {
        category: '',
        categoryIds: [308],
        translationKey: 'table.offensive.goalkeeper.successful_short_pass',
      },
      {
        category: '',
        categoryIds: [309],
        translationKey: 'table.offensive.goalkeeper.unsuccessful_short_pass',
      },
    ],
  },
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.offensive.goalkeeper.throw',
    items: [
      {
        category: '',
        categoryIds: [304],
        translationKey: 'table.offensive.goalkeeper.successful_throw',
      },
      {
        category: '',
        categoryIds: [305],
        translationKey: 'table.offensive.goalkeeper.unsuccessful_throw',
      },
    ],
  },
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.offensive.goalkeeper.punt',
    items: [
      {
        category: '',
        categoryIds: [306],
        translationKey: 'table.offensive.goalkeeper.successful_punt',
      },
      {
        category: '',
        categoryIds: [307],
        translationKey: 'table.offensive.goalkeeper.unsuccessful_punt',
      },
    ],
  },
  {
    category: '',
    categoryIds: [323],
    items: null,
    translationKey: 'table.offensive.goalkeeper.participation_in_goals',
  },
];

// Data structure for the offensive table data rows
export const defensiveGoalkeeperTableRowItems = [
  {
    category: '',
    categoryIds: [40],
    items: null,
    translationKey: 'table.defensive.goalkeeper.goals_received',
  },
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.defensive.goalkeeper.saves',
    items: [
      {
        category: '',
        categoryIds: [300],
        translationKey: 'table.defensive.goalkeeper.goalkeeper_handled',
        generalName: 'Atajadas que se queda con el balón',
      },
      {
        category: '',
        categoryIds: [301],
        translationKey: 'table.defensive.goalkeeper.goalkeeper_un-handled',
        generalName: 'Atajadas que no se queda con el balón',
      },
    ],
  },
  {
    category: '',
    categoryIds: null,
    translationKey: 'table.defensive.goalkeeper.aerial_game',
    items: [
      {
        category: '',
        categoryIds: [313],
        translationKey: 'table.defensive.goalkeeper.successful_handled',
        generalName: 'Juego aéreo exitoso que se queda con el balón',
      },
      {
        category: '',
        categoryIds: [314],
        translationKey: 'table.defensive.goalkeeper.successful_un-handled',
        generalName: 'Juego aéreo exitoso que no se queda con el balón',
      },
    ],
  },
  {
    category: '',
    categoryIds: [41],
    items: null,
    translationKey: 'table.defensive.goalkeeper.1_on_1',
  },
  {
    category: '',
    categoryIds: [312],
    items: null,
    translationKey: 'table.defensive.goalkeeper.recovered_balls',
  },
];

// ToDo: Pending to change a factory to return desired array based on arguments
export function createPossessionGoalkeeperRows() {
  return possessionGoalkeeperTableRowItems.map(
    ({ category, categoryIds, translationKey, items = null, generalName = '' }) => {
      return new PlayerTableRow(category, categoryIds, translationKey, items, generalName);
    },
  );
}

export function createOffensiveGoalkeeperRows() {
  return offensiveGoalkeeperTableRowItems.map(
    ({ category, categoryIds, translationKey, items = null, generalName = '' }) => {
      return new PlayerTableRow(category, categoryIds, translationKey, items, generalName);
    },
  );
}
export function createDefensiveGoalkeeperRows() {
  return defensiveGoalkeeperTableRowItems.map(
    ({ category, categoryIds, translationKey, items = null, generalName = '' }) => {
      return new PlayerTableRow(category, categoryIds, translationKey, items, generalName);
    },
  );
}

export const allCategories = (function() {
  let allCategories = [];
  allCategories = allCategories.concat(getDataTablesCategories(possessionGoalkeeperTableRowItems));
  allCategories = allCategories.concat(getDataTablesCategories(offensiveGoalkeeperTableRowItems));
  allCategories = allCategories.concat(getDataTablesCategories(defensiveGoalkeeperTableRowItems));
  return allCategories;
})();
